import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { AdsReport } from "@/components/ads/AdsReport";

const NETS = [["facebook", "Facebook page"], ["instagram", "Instagram"], ["google_business", "Google Business Profile"], ["tiktok", "TikTok"], ["youtube", "YouTube"], ["x", "X (Twitter)"]];

const Socials = ({ slug, initial }) => {
  const [f, setF] = useState(initial);
  const [busy, setBusy] = useState(false);
  const save = async () => { setBusy(true); try { const { data } = await api.put(`/api/ads/portal/${slug}/socials`, f); setF(data.socials); toast.success("Social pages connected"); } catch (e) { toast.error(errMsg(e)); } setBusy(false); };
  return (
    <section className="bg-white border border-slate-200 rounded-2xl p-5 space-y-3" data-testid="ads-socials">
      <div><p className="font-bold">Your social pages</p><p className="text-xs text-slate-500">Add your profile links. They show on your directory page, and our ads team uses them to run Facebook, Instagram and Google ads for you.</p></div>
      <div className="grid sm:grid-cols-2 gap-2">{NETS.map(([k, l]) => <label key={k} className="text-xs font-semibold text-slate-600 space-y-1"><span>{l}</span><input value={f[k] || ""} onChange={e => setF({ ...f, [k]: e.target.value })} placeholder={`https://…`} className="w-full h-10 border border-slate-300 rounded-lg px-3 text-sm" data-testid={`ads-social-${k}`} /></label>)}</div>
      <button onClick={save} disabled={busy} className="h-10 px-5 rounded-full bg-slate-900 text-white text-sm font-bold flex items-center gap-2 disabled:opacity-50" data-testid="ads-social-save">{busy && <Loader2 className="w-4 h-4 animate-spin" />}Save social pages</button>
    </section>
  );
};

export const AdsTab = ({ slug }) => {
  const [r, setR] = useState(null);
  const [days, setDays] = useState(30);
  useEffect(() => { api.get(`/api/ads/portal/${slug}`, { params: { days } }).then(x => setR(x.data)).catch(e => toast.error(errMsg(e))); }, [slug, days]);
  if (!r) return <Loader2 className="w-5 h-5 animate-spin" />;
  return (
    <div className="space-y-5" data-testid="portal-ads">
      <div className="flex items-center gap-2"><p className="font-bold flex-1">Google & Facebook/Instagram ads</p><select value={days} onChange={e => setDays(+e.target.value)} className="h-9 border rounded-lg px-2 text-sm" data-testid="ads-days">{[7, 30, 90].map(n => <option key={n} value={n}>Last {n} days</option>)}</select></div>
      <AdsReport r={r} />
      <Socials slug={slug} initial={r.socials} />
    </div>
  );
};
